module.exports = __webpack_public_path__ + "img/boras-elhandel.f1671d93.svg";